"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _CarouselModal = require("./CarouselModal.scss");

var _CarouselModal2 = _interopRequireDefault(_CarouselModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselModal = function CarouselModal(props) {
  var show = props.show,
      strings = props.strings,
      onClose = props.onClose;

  var classes = (0, _classnames2.default)({
    carouselModal: true,
    enableModal: show,
    disableModal: !show
  });

  return _react2.default.createElement(
    "div",
    { className: classes },
    _react2.default.createElement(
      "button",
      { className: "carouselModal__buttonClose", onClick: onClose },
      _react2.default.createElement("span", { className: "carouselModal__buttonClose__icon icon-close" })
    ),
    _react2.default.createElement(
      "h3",
      { className: "carouselModal__subTitle" },
      strings.subTitle
    ),
    _react2.default.createElement("p", { className: "carouselModal__text", dangerouslySetInnerHTML: { __html: strings.text || "" } })
  );
};

exports.default = CarouselModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/CarouselModal.jsx
// module id = 691
// module chunks = 0